"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACProfileMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = require("react");
var ACProfileMenu = function (props) {
    var _a, _b, _c;
    var items = (0, react_1.useMemo)(function () {
        return props.items.map(function (item) {
            var _a;
            return __assign(__assign({}, item), { icon: "", label: ((0, jsx_runtime_1.jsxs)("span", { className: "font-medium flex items-center gap-2", children: [(item === null || item === void 0 ? void 0 : item.icon) ? ((0, jsx_runtime_1.jsx)("i", { className: (_a = "aci ".concat(item === null || item === void 0 ? void 0 : item['icon'], " ").concat(item === null || item === void 0 ? void 0 : item.iconClassName)) === null || _a === void 0 ? void 0 : _a.trim() })) : (''), item === null || item === void 0 ? void 0 : item.label] })) });
        });
    }, [props.items]);
    var onClick = function (_a) {
        var key = _a.key;
        var item = items.find(function (e) { return (e === null || e === void 0 ? void 0 : e.key) === key; });
        props === null || props === void 0 ? void 0 : props.executeEventHandlers((item === null || item === void 0 ? void 0 : item.handlers) || [], item, null);
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Dropdown, { menu: { items: items, onClick: onClick }, trigger: ['click'], children: (0, jsx_runtime_1.jsx)(antd_1.Avatar, { className: props === null || props === void 0 ? void 0 : props.avatarClassName, children: (0, jsx_runtime_1.jsx)("span", { className: "text-[12px]", children: (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.avatarText) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === null || _b === void 0 ? void 0 : _b.split(' ')) === null || _c === void 0 ? void 0 : _c.map(function (word) { return word[0]; }).slice(0, 2).join('') }) }) }));
};
exports.ACProfileMenu = ACProfileMenu;
